import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { listViewUrl, formUrl, loginUrl } from "../constants/Routes";
import ListView from "../pages/list-view/ListView";
import Form from "../pages/form/Form";
import LoginView from "../pages/login/LoginView";

export function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={listViewUrl} element={<ListView />} />
        <Route path={formUrl} element={<Form />} />
        <Route path={loginUrl} element={<LoginView />} />
      </Routes>
    </BrowserRouter>
  );
}
